import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OfflineBannerComponent } from './shared/offline-banner/offline-banner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, OfflineBannerComponent],
  template: '<app-offline-banner></app-offline-banner><router-outlet></router-outlet>',
})
export class App {}
